
export default function FieldActivityFinder(collectionToSearch, faId) {

    const isMatchingFieldActivity = ({FieldActivityId}) => FieldActivityId === faId;
    const indexOfMatch = collectionToSearch.findIndex(isMatchingFieldActivity);
    let fa = collectionToSearch[indexOfMatch];
    let ret = {
        update: fa,
        index: indexOfMatch
    };
    return ret;
}

//export default { FieldActivityFinder };